import { IOptionState, IOptionStateFulfilled, IStateRejected } from '../../interfaces';
import optionsAction from '../actions/option.action';

const findAllOption = () => {
  const { pending, fulfilled, rejected } = optionsAction.findAllOption;
  return {
    // Pending
    [pending.type]: (state: IOptionState): IOptionState => ({
      ...state,
      status: 'loading',
      error: '',
    }),
    // Fulfilled
    [fulfilled.type]: (_: IOptionState, action: IOptionStateFulfilled): IOptionState => ({
      status: 'success',
      options: action.payload,
      error: '',
    }),
    // Rejected
    [rejected.type]: (_: IOptionState, action: IStateRejected): IOptionState => ({
      options: [],
      status: 'error',
      error: action.error.message,
    }),
  };
};

const findAllOptionWithSuboption = () => {
  const { pending, fulfilled, rejected } = optionsAction.findAllOptionWithSuboption;
  return {
    // Pending
    [pending.type]: (state: IOptionState): IOptionState => ({
      ...state,
      status: 'loading',
      error: '',
    }),
    // Fulfilled
    [fulfilled.type]: (_: IOptionState, action: IOptionStateFulfilled): IOptionState => ({
      status: 'success',
      options: action.payload,
      error: '',
    }),
    // Rejected
    [rejected.type]: (_: IOptionState, action: IStateRejected): IOptionState => ({
      options: [],
      status: 'error',
      error: action.error.message,
    }),
  };
};

export default {
  ...findAllOption(),
  ...findAllOptionWithSuboption(),
};
